export default __webpack_public_path__ + "static/media/Cabin2.bef1adfe.jpg";